import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';

import { AngularSvgIconModule } from 'angular-svg-icon';

import { FellohSuccessComponent } from './components/felloh-success/felloh-success.component';
import { FellohFailureComponent } from './components/felloh-failure/felloh-failure.component';
import { BadRequestComponent } from './components/bad-request/bad-request.component';
import { BookingDetailsComponent } from './components/booking-details/booking-details.component';
import { ItineraryComponent } from './components/itinerary/itinerary.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { QuoteDetailsComponent } from './components/quote/quote.component';
import { MintFailureComponent } from './components/mint/mint-failure/mint-failure.component';
import { MintSuccessComponent } from './components/mint/mint-success/mint-success.component';

export const MY_FORMATS = {
  parse: {
      dateInput: ['LL', "DD/MM/YYYY"]
  },
  display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'YYYY'
  }
};

@NgModule({ declarations: [
        AppComponent,
        FellohSuccessComponent,
        FellohFailureComponent,
        MintFailureComponent,
        MintSuccessComponent,
        BadRequestComponent,
        BookingDetailsComponent,
        ItineraryComponent,
        QuoteDetailsComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatListModule,
        MatRadioModule,
        MatGridListModule,
        MatExpansionModule,
        NgApexchartsModule,
        MatSidenavModule,
        MatDialogModule,
        MatDividerModule,
        MatProgressBarModule,
        MatInputModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        FlexLayoutModule,
        AngularSvgIconModule.forRoot()], providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
